import {AfterViewInit, Component, OnInit} from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {ActivatedRoute} from '@angular/router';
import * as Chart from 'chart.js';
import { UserService } from '../../../../core/user.service';
import { AuthService } from '../../../../core/auth/auth.service';

@Component({
  selector: 'app-cqmns-classification-trend',
  templateUrl: './cqmns-classification-trend.component.html',
  styleUrls: ['./cqmns-classification-trend.component.css']
})
export class CqmnsClassificationTrendComponent implements OnInit {
  filter;
  value;
  canvas: any;
  ctx: any;
  myTrend: any;
  classifications = [];
  noOfClassifications = [];
  results: any;
  projectId: any;
  classes: any;
  headers = new HttpHeaders();
  hostUrl =this.userService.getUrl();
  toDate = new Date().toISOString().substring(0,10)+' 23:59:59';
  fromDate = new Date(new Date().getTime() - 6 * 24 * 60 * 60 * 1000).toISOString().substring(0,10)+' 00:00:00';
  months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
  sources;
  selectedSource="All";
  colors = [
    'rgba(255,219,105)',
    'rgba(26,187,156)',
    'rgba(150,3,3)',
    'rgba(3,66,128)',
    "rgba(100,118,137)",
    "rgb(69,39,160)",   
    ];
  userId: any;
  constructor(private http: HttpClient, private route: ActivatedRoute,  private userService: UserService, private authService: AuthService, ) {}

  ngOnInit() {
    this.authService.user() .subscribe(
      data => {});
      this.value = 'day';
      this.filter = 'day';
     // this.projectId = this.route.snapshot.params['projectId'];
     this.userId = localStorage.getItem("userid");

      this.projectId = localStorage.getItem("projectId");
      this.http.get(encodeURI(this.hostUrl+'/api/issue/countByClassification/' + this.projectId))
          .subscribe( data => {
              for (const k in data) {
                  if (k !== 'null') {
                      this.classifications.push(k);
                      this.noOfClassifications.push(data[k] ? data[k] : 0);
                  }
              }
              this.updateChart(this.myTrend);
          });

      this.headers = this.headers.append('Content-Type', 'application/json');
      this.http.get(encodeURI(this.hostUrl+'/api/issue/sources/' + this.projectId))
          .subscribe( data => {
              this.sources=data;
          });
          
  }    

  ngAfterViewInit() {

      Chart.defaults.global.defaultFontColor = '#000';
      this.canvas = document.getElementById('myTrend');
      this.ctx = this.canvas.getContext('2d');
      this.myTrend = new Chart(this.ctx, {
          type: 'line',
          data: {
              labels: [],
              datasets: [
              ]
          },
          options: {
            legend: {
              display: true,
              position: 'bottom',
              labels: {
                fontSize:12,
                fontColor:'#2a3f54',
               
              }
               // place legend on the right side of chart
           },
              scales: {
                 xAxes: [
                {
                  gridLines: {
                    display:false
                },
                scaleLabel: {
                  display: true,
                  labelString: 'Day/Month/Year',
                  fontFamily: 'verdana',
                  fontSize: 12
                },
                }
              ],
                  yAxes: [{
                      gridLines: {
                       display:true
                    },
                    scaleLabel: {
                      display: true,
                      labelString: 'Count',
                      fontFamily: 'verdana',
                      fontSize: 12,
                     
                    },
                    ticks: {
                      beginAtZero: true,
                      userCallback: function(label, index, labels) {
                          // when the floored value is the same as the value we have a whole number
                          if (Math.floor(label) === label) {
                              return label;
                          }
     
                      },
                  }
                  }]
              },
              responsive: true,
              display: true,
              maintainAspectRatio: false
          }
      });
      this.fetchData();
  }
  getFrom(e) {
      let finalMM = '';
      let finaldd = ''; 
      if (this.value === 'day'){   
      this.fromDate = e.target.value + ' 00:00:00';   
      const tempDate = new Date(this.fromDate);   
      tempDate.setDate(tempDate.getDate() + 6);   
      const yyyy = tempDate.getFullYear();   
      const MM = tempDate.getMonth() + 1;   
      const dd = tempDate.getDate();
  
  
      if (MM < 10) {
        finalMM = '0' + MM;
      } else {
        finalMM = '' + MM;
      }
      if (dd < 10) {
        finaldd = '0' + dd;
      } else {
        finaldd = '' + dd;
      }
      this.toDate = yyyy + '-' + finalMM + '-' + finaldd;
      this.fetchData();
    }
    else if (this.value === 'year'){   
      this.fromDate = e.target.value + ' 00:00:00';   
      const tempDate = new Date(this.fromDate);   
      tempDate.setMonth(tempDate.getMonth() + 72);   
      const yyyy = tempDate.getFullYear();   
      const MM = tempDate.getMonth() + 1;   
      const dd = tempDate.getDate();    
      if (MM < 10) {
        finalMM = '0' + MM;
      } else {
        finalMM = '' + MM;
      }
      if (dd < 10) {
        finaldd = '0' + dd;
      } else {
        finaldd = '' + dd;
      }
      this.toDate = yyyy + '-' + finalMM + '-' + finaldd;
      this.fetchData();
    }
    else if (this.value === 'month'){   
      this.fromDate = e.target.value + ' 00:00:00';   
      const tempDate = new Date(this.fromDate);   
      tempDate.setDate(tempDate.getDate());   
      tempDate.setMonth(tempDate.getMonth() + 11);   
      const yyyy = tempDate.getFullYear();   
      const MM = tempDate.getMonth() + 1;   
      const dd = tempDate.getDate();
  
  
      if (MM < 10) {
        finalMM = '0' + MM;
      } else {
        finalMM = '' + MM;
      }
      if (dd < 10) {
        finaldd = '0' + dd;
      } else {
        finaldd = '' + dd;
      }
      this.toDate = yyyy + '-' + finalMM + '-' + finaldd;
      this.fetchData();
    }
  }
  
    getTo(e) {
      let finalMM = '';
      let finaldd = '';
      if (this.value === 'day'){  
      this.toDate = e.target.value + ' 00:00:00';
      const tempDate = new Date(this.toDate);
      tempDate.setDate(tempDate.getDate() - 6);
      tempDate.setMonth(tempDate.getMonth());   
      const yyyy = tempDate.getFullYear();
      const MM = tempDate.getMonth() + 1;
      const dd = tempDate.getDate();
      if (MM < 10) {
        finalMM = '0' + MM;
      } else {
        finalMM = '' + MM;
      }
      if (dd < 10) {
        finaldd = '0' + dd;
      } else {
        finaldd = '' + dd;
      }
      this.fromDate = yyyy + '-' + finalMM + '-' + finaldd;
      this.fetchData();
    }
    else if (this.value === 'year'){  
      this.toDate = e.target.value + ' 00:00:00';
      const tempDate = new Date(this.toDate);
      tempDate.setMonth(tempDate.getMonth() - 72);
      const yyyy = tempDate.getFullYear();
      const MM = tempDate.getMonth() + 1;
      const dd = tempDate.getDate();
      if (MM < 10) {
        finalMM = '0' + MM;
      } else {
        finalMM = '' + MM;
      }
      if (dd < 10) {
        finaldd = '0' + dd;
      } else {
        finaldd = '' + dd;
      }
      this.fromDate = yyyy + '-' + finalMM + '-' + finaldd;
      this.fetchData();
    }
    else if (this.value === 'month'){  
      this.toDate = e.target.value + ' 00:00:00';
      const tempDate = new Date(this.toDate);
      tempDate.setDate(tempDate.getDate());   
      tempDate.setMonth(tempDate.getMonth() - 11);  
      const yyyy = tempDate.getFullYear();
      const MM = tempDate.getMonth() + 1;
      const dd = tempDate.getDate();
      if (MM < 10) {
        finalMM = '0' + MM;
      } else {
        finalMM = '' + MM;
      }
      if (dd < 10) {
        finaldd = '0' + dd;
      } else {
        finaldd = '' + dd;
      }
      this.fromDate = yyyy + '-' + finalMM + '-' + finaldd;
      this.fetchData();
    }
  }

  updateChart(myTrend) {
      this.myTrend.data.datasets = [];
      this.myTrend.data.labels = [];
      myTrend.update();
      for (let i = 0; i < this.classifications.length; i++) {
          myTrend.data.datasets.push({
              label: this.classifications[i],
              data: new Array(12).fill(0),
              borderColor: this.getColor(i),
             // backgroundColor: this.getRandomColor(),
              //fill: true,
          });
      }
      myTrend.update();

  }

  getRandomColor() {
      const letters = '0123456789ABCDEF';
      let color = '#';
      for (let i = 0; i < 6; i++) {
          color += letters[Math.floor(Math.random() * 16)];
      }
      return color;
  }

  onChange(e){
      this.value = e.target.value;
      this.fetchData();
  }

  fetchData(){
      if(this.value === 'month'){
          this.month(this.myTrend);
      }else if(this.value === 'day'){
          this.day(this.myTrend);
      }else if(this.value === 'year'){
          this.year(this.myTrend);
      }
  }

  month(myTrend){
      const updateBody = {'from': this.fromDate, 'to' : this.toDate };
      this.http
      .post(
          encodeURI(this.hostUrl+'/api/issue/trendsByMonth/' + this.projectId), 
          updateBody, {headers: this.headers}
      )
          .subscribe(data => {
              this.results = data; 
              this.updateChart(this.myTrend);

              let fdate = this.fromDate;
              let stringdate = parseInt(fdate.slice(5,7))
              let startMonth = stringdate-1;
              let monthArray = [];
              if(startMonth ==0){
                  monthArray = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
              }

              else {
                  for( let i = startMonth; i < 12;i++ ){
                      monthArray.push(this.months[i]);
                  }
                  for( let i=0;i< startMonth;i++){
                      monthArray.push(this.months[i]);
                  }

              }
              for(let j=0; j <12; j++){
                  myTrend.data.labels.push(monthArray[j]);
              }
              
              for (let i = 0; i < this.results.length; i++) {
                  this.http
                  .post(
                      encodeURI(
                          this.hostUrl+
                          '/api/issue/trendsByMonthId/' + 
                          this.projectId + 
                          '/' + 
                          this.results[i]['trendmonth']
                      ),
                      updateBody, 
                      {headers: this.headers}
                  )
                      .subscribe(data => {
                           
                          let a = this.results[i]['trendmonth']
                          switch(a){
                              case 1: a = monthArray.indexOf('January');
                              break;
                              case 2 : a = monthArray.indexOf('February');
                              break;
                              case 3: a = monthArray.indexOf('March');
                              break;
                              case 4 : a = monthArray.indexOf('April');
                              break;
                              case 5: a = monthArray.indexOf('May');
                              break;
                              case 6 : a = monthArray.indexOf('June');
                              break;
                              case 7: a = monthArray.indexOf('July');
                              break;
                              case 8 : a = monthArray.indexOf('August');
                              break;
                              case 9: a = monthArray.indexOf('September');
                              break;
                              case 10 : a = monthArray.indexOf('October');
                              break;
                              case 11: a = monthArray.indexOf('November');
                              break;
                              case 12: a = monthArray.indexOf('December');
                              break;
                          }
                          for (const j in data) {
                              myTrend.update();
                              for (let k = 0; k < this.myTrend.data.datasets.length; k++) {
                                  myTrend.update();
                                  if (data[j].approvedClassification === 
                                      this.myTrend.data.datasets[k].label
                                  ) {

                                      myTrend.data.datasets[k].data[a] += 
                                      data[j]['countmonth'];
                                      myTrend.update();
                                      break;
                                  }
                              }
                          }
                      });
              }
          });
      myTrend.update();
  }

  day(myTrend){
      const updateBody = {
          from: this.fromDate,
          to: this.toDate,
          source: this.selectedSource
        };
      this.http.post(encodeURI(this.hostUrl+'/api/issue/trendsByDay/' + this.projectId), updateBody, {headers: this.headers})
          .subscribe( data => {
              this.results = data;
              this.updateChart(this.myTrend);
              let tempDate = new Date(this.fromDate);

  for (let m = 0; m < 7; m++) {
      let finalMM = '';
      let finaldd = '';
      let yyyy = tempDate.getFullYear();
      let MM = tempDate.getMonth() + 1;
      let dd = tempDate.getDate();
      if (MM < 10) {
          finalMM = '0' + MM;
        } else {
          finalMM = '' + MM;
        }
        if (dd < 10) {
          finaldd = '0' + dd;
        } else {
          finaldd = '' + dd;
        }

      let dateToCheck = yyyy + '-' + finalMM + '-' + finaldd;
      myTrend.data.labels.push(dateToCheck);

      tempDate.setDate(tempDate.getDate() + 1);
      this.http
        .post(
          encodeURI(
            this.hostUrl +
              '/api/issue/trendsByDayId/' +
              this.projectId +
              '/' +
              dateToCheck
          ),
          updateBody,
          { headers: this.headers }
        )
        .subscribe(data => {    
          for (const j in data) {
              myTrend.update();
              for (let k = 0; k < this.myTrend.data.datasets.length; k++) {
                myTrend.update();
                if (
                  data[j].approvedClassification ===
                  this.myTrend.data.datasets[k].label
                ) {
                  this.myTrend.data.datasets[k].data[m] =
                    data[j]['countday'];
                  myTrend.update();
                  break;
                }
              }
            }
        });        
    }

          });
      myTrend.update();
  }
  year(myTrend){
      const updateBody = {'from': this.fromDate, 'to' : this.toDate, 'source':this.selectedSource };
      this.http
      .post(
          encodeURI(this.hostUrl+'/api/issue/trendsByYear/' + this.projectId),
           updateBody, 
           {headers: this.headers}
          )
          .subscribe( data => {
              this.results = data;
              this.updateChart(this.myTrend);
              let tempDate = new Date(this.fromDate);

              for (let m = 0; m < 7; m++) {
                  let finalMM = '';
                  let finaldd = '';
                  let yyyy = tempDate.getFullYear();
                  let MM = tempDate.getMonth() + 72;
                  let dd = tempDate.getDate();
                  if (MM < 10) {
                      finalMM = '0' + MM;
                    } else {
                      finalMM = '' + MM;
                    }
                    if (dd < 10) {
                      finaldd = '0' + dd;
                    } else {
                      finaldd = '' + dd;
                    }
          
                  let dateToCheck = yyyy;
                  myTrend.data.labels.push(dateToCheck);

                  tempDate.setFullYear(tempDate.getFullYear() + 1);
        
                  this.http
                  .post(
                      encodeURI(
                          this.hostUrl+
                          '/api/issue/trendsByYearId/' + 
                          this.projectId + 
                          '/' + 
                          dateToCheck
                      ),
                      updateBody, 
                      {headers: this.headers}
                     )
                      .subscribe(data1 => {
                          for(const j in data1){
                              myTrend.update();
                              for (let k = 0; k < this.myTrend.data.datasets.length; k++) {
                                  myTrend.update();                                    
                                  if (
                                      data1[j].approvedClassification === 
                                      this.myTrend.data.datasets[k].label
                                  ) {
                                      this.myTrend.data.datasets[k].data[m] += 
                                        data1[j]['countyear'];
                                      myTrend.update();
                                      break;
                                  }
                              }
                          }
                      })
              }
          });
      myTrend.update();
  }
  getColor(num) {
    if (num <= 6) {
      return this.colors[num];
    } else {
      this.getRandomColor();
    }
  }
}





// WEBPACK FOOTER //
// ./src/app/modules/cqm-ns/cqm-ns-defect/cqmns-classification-trend/cqmns-classification-trend.component.ts